import './_account-login-form.scss';
import component from './account-login-form';

export default component;
